import { render, staticRenderFns } from "./IColectivo.vue?vue&type=template&id=7f945619&scoped=true&"
var script = {}
import style0 from "./IColectivo.vue?vue&type=style&index=0&id=7f945619&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f945619",
  null
  
)

export default component.exports